export default ({ TituloPagina, Descripcion, Metadata }) => ({
    title: TituloPagina,
    description: Descripcion,
    metadata: Metadata
})